import React, { FunctionComponent, SVGProps } from 'react'

export const IconCorner: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="var(--bg-contrast, #41434E)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.48039 14.6245C10.2806 15.6829 11.8709 15.6829 12.6711 14.6245L20.8417 3.81762C21.8378 2.50014 20.898 0.61145 19.2463 0.61145H2.90518C1.25353 0.61145 0.313737 2.50014 1.30982 3.81762L9.48039 14.6245Z" />
    </svg>
  )
}
